import { ref, watch, reactive } from 'vue';
import type { HeadingLevel } from '@/utils/a11y';

export interface UseAthleteProfileDrawerState {
  isOpen: boolean;
  athleteTwrn: string;
  budgetTwrn: string | undefined;
  academicYearId: string | undefined;
  defaultPositionAcademicYearId: string | undefined;
  headingLevel: HeadingLevel;
}

const DEFAULT_STATE: UseAthleteProfileDrawerState = {
  isOpen: false,
  athleteTwrn: '',
  budgetTwrn: undefined,
  academicYearId: undefined,
  defaultPositionAcademicYearId: undefined,
  headingLevel: 3,
};

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseAthleteProfileDrawerState>(getDefaultState());

function resetState() {
  Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
  if (!isOpen) resetState();
});

export function useAthleteProfileDrawer() {
  async function open(
    athleteTwrn: string,
    budgetTwrn?: string,
    academicYearId?: string,
    headingLevel?: HeadingLevel,
    defaultPositionAcademicYearId?: string,
  ) {
    state.athleteTwrn = athleteTwrn;
    state.budgetTwrn = budgetTwrn;
    state.academicYearId = academicYearId;
    state.defaultPositionAcademicYearId = defaultPositionAcademicYearId;
    state.headingLevel = headingLevel ?? 3;
    state.isOpen = true;
  }

  return {
    state,
    isRendered,
    resetState,
    open,
  };
}
